import Team from './Team.page';

export default Team;